<div class="card">
  <div class="card-header fw-bold">
    {{ 'Sellers.Dashboard.BalanceInfo' | translate }}
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6 col-md-4 col_info">
        <p class="text-center">
          {{ 'Sellers.Dashboard.AvailableBalanceDescription' | translate }}
        </p>
        <div class="row justify-content-center">
          <button class="btn btn-info col-5">
            {{ 'Sellers.Dashboard.AvailableBalance' | translate }}
          </button>
          <div class="border border-info rounded color-info fw-bold text-center py-2 col-6">
            {{balanceObject.avalibleBalance}}
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-4 col_info">
        <p class="text-center">
          {{ 'Sellers.Dashboard.CashWalletBalanceDescription' | translate }}
        </p>
        <div class="row justify-content-center">
          <button class="btn btn-info col-5">
            {{ 'Sellers.Dashboard.CashWalletBalance' | translate }}
          </button>
          <div class="border border-info rounded color-info fw-bold text-center py-2 col-6">
            {{balanceObject.netWithdrawalsCashoutBalance}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card mt-4">
  <div class="card-header fw-bold">
    {{ 'Sellers.Dashboard.AddCashWallet' | translate }}
  </div>

  <app-add-cash-out-wallet-request>
  </app-add-cash-out-wallet-request>
</div>

<div class="card mt-4">
  <div class="card-header fw-bold">
    {{ 'Sellers.Dashboard.ResetWalletBalance' | translate }}
  </div>
  <div class="card-body">
    <p class="">
      {{ 'Sellers.Dashboard.ResetWalletBalanceDescription' | translate }}
    </p>
    <button class="btn btn-primary" (click)="onResetWalletBalance()">
      {{ 'Sellers.Dashboard.ResetWalletBalance' | translate }}
    </button>
  </div>
</div>

<div class="card mt-4">
  <div class="card-header fw-bold">
    {{ 'Sellers.Dashboard.AddBulkCashOut' | translate }}
  </div>
  <div class="card-body">
    <button class="btn btn-primary" (click)="onUploadClick()">
      {{ 'Sellers.Products.Upload' | translate }}
    </button>
  </div>
</div>

<div class="card mt-4">
  <div class="card-header fw-bold">
    {{ 'Sellers.Dashboard.AddCashOut' | translate }}
  </div>
  <div class="card-body" *ngIf="stepForm">
    <form [formGroup]="stepForm" *ngIf="stepForm">
      <div class="row ng-star-inserted">
        <div class="col-md-4">
          <app-product-name [fieldObject]="controllers['Title']"
                            [fieldErrors]="formValidator.formErrors"
                            [formControlRef]="convertControls(controllers['Title'].fieldName)"
                            [productType]="productTypeId"
                            [isUpdate]="isUpdate"></app-product-name>
        </div>

        <div class="col-md-4">
          <app-number [fieldObject]="controllers['Amount']"
                      [fieldErrors]="formValidator.formErrors"
                      [showIcon]="true"
                      [toolTipMsg]="('Sellers.Products.AmountBetween' | translate)"
                      [formControlRef]="convertControls(controllers['Amount'].fieldName)"
                      [productType]="productTypeId"
                      [isUpdate]="isUpdate"></app-number>
        </div>

        <div class="col-md-4">
          <app-select-list [fieldObject]="controllers['Cash Type']"
                           [fieldErrors]="formValidator.formErrors"
                           [formControlRef]="convertControls('Cash Type')"
                           [productType]="productTypeId"
                           [isUpdate]="isUpdate"></app-select-list>
        </div>

        <div class="col-md-6">
          <app-text [fieldObject]="controllers['Name']"
                    [fieldErrors]="formValidator.formErrors"
                    [formControlRef]="convertControls('Name')"
                    [productType]="productTypeId"
                    [isUpdate]="isUpdate"></app-text>
        </div>

        <div class="col-md-6">
          <app-text [fieldObject]="controllers['Payer Email']"
                    [fieldErrors]="formValidator.formErrors"
                    [formControlRef]="convertControls('Payer Email')"
                    [productType]="productTypeId"
                    [isUpdate]="isUpdate"></app-text>
        </div>

        <div class="col-md-6">
          <app-text [fieldObject]="controllers['Payer Mobile Number']"
                    [fieldErrors]="formValidator.formErrors"
                    [formControlRef]="convertControls('Payer Mobile Number')"
                    [productType]="productTypeId"
                    [isUpdate]="isUpdate"></app-text>
        </div>

        <div class="col-md-4" *ngIf="isCashTypeReceived">
          <app-select-list [fieldObject]="controllers['Cash Expiry Duration']"
                           [fieldErrors]="formValidator.formErrors"
                           [formControlRef]="convertControls('Cash Expiry Duration')"
                           [productType]="productTypeId"
                           [isUpdate]="isUpdate"></app-select-list>
        </div>

        <div class="col-md-12">
          <app-text-area [fieldObject]="controllers['Description']"
                         [fieldErrors]="formValidator.formErrors"
                         [formControlRef]="convertControls(controllers['Description'].fieldName)"
                         [productType]="productTypeId"
                         [isUpdate]="isUpdate"></app-text-area>
        </div>
      </div>
    </form>
    <button [disabled]="isSubmitting || !stepForm.valid"
            class="btn btn-primary m-2 pull-right" type="button"
            (click)="submit()">
      {{ 'Sellers.Products.Submit' | translate }}
    </button>
  </div>
</div>
